import React, { useState } from 'react'
import FrontCard from '../components/FrontCard'
import BackCard from '../components/BackCard'
import ReactCardFlip from 'react-card-flip'

const Jumbotron = () => {
  let [isFlippedMake, makeHandler] = useState(false)
  let [isFlippedBake, bakeHandler] = useState(false)
  let [isFlippedBuild, buildHandler] = useState(false)

  return (
    <div style={styles.jumbotronContainer}>
      <div style={styles.headline}>
        <header style={styles.header}>
          <h1>Nick Gowdy</h1>
        </header>
        <div style={styles.flexContainer}>
          <ReactCardFlip isFlipped={isFlippedMake}>
            <div onClick={e => makeHandler(isFlippedMake = !isFlippedMake)}>
              <FrontCard title='Make' isFlipped={isFlippedMake} />
            </div>
            <div onClick={e => makeHandler(isFlippedMake = !isFlippedMake)}>
              <BackCard content='Interactive web and mobile apps' />
            </div>
          </ReactCardFlip>

          <ReactCardFlip isFlipped={isFlippedBake} >
            <div onClick={e => bakeHandler(isFlippedBake = !isFlippedBake)}>
              <FrontCard title='Bake' isFlipped={isFlippedBake} />
            </div>
            <div onClick={e => bakeHandler(isFlippedBake = !isFlippedBake)}>
              <BackCard title='' content='Something to satisfy your sweet tooth' />
            </div>
          </ReactCardFlip>

          <ReactCardFlip isFlipped={isFlippedBuild} >
            <div onClick={e => buildHandler(isFlippedBuild = !isFlippedBuild)}>
              <FrontCard title='Build' content='' isFlipped={isFlippedBuild} />
            </div>
            <div onClick={e => buildHandler(isFlippedBuild = !isFlippedBuild)}>
              <BackCard title='' content='With good software engineering' />
            </div>
          </ReactCardFlip>
        </div>
      </div>
    </div>
  )
}

const styles = {
  flexContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer'

  },
  jumbotronContainer: {
    marginTop: '42px',
    padding: '2rem',
    backgroundColor: '#659DBD',
    color: 'white'
  },
  headline: {
    padding: '1rem',
    margin: 'auto',
    paddingTop: '200px',
    textAlign: 'center'
  },
  header: {
    margin: 'auto',
    fontamily: 'Signika sans-serif',
    paddingBottom: '10px',
    borderBottom: '1px solid #ffffff',
    fontSize: '28px'
  }
}

export default Jumbotron
